// Formatadores locais do Cotado × Realizado (PO1-3621). Não usar formatCurrency
// com string: os números chegam como number do backend.
import moment from "moment";

export const fmtBRL = (v) =>
  v === null || v === undefined
    ? "—"
    : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 });

export const fmtInt = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString("pt-BR"));

export const fmtPct = (v, casas = 1) =>
  v === null || v === undefined || !Number.isFinite(Number(v))
    ? "—"
    : `${Number(v).toLocaleString("pt-BR", { minimumFractionDigits: casas, maximumFractionDigits: casas })}%`;

export const fmtPctSigned = (v) => {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  return `${n > 0 ? "+" : ""}${n.toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
};

// Razão (ex.: realizado ÷ cotado = 1,04).
export const fmtRazao = (v) =>
  v === null || v === undefined || !Number.isFinite(Number(v))
    ? "—"
    : Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtData = (v) => (v ? moment(String(v).slice(0, 10)).format("DD/MM/YYYY") : "—");

export const fmtDataHora = (v) => (v ? moment(v).format("DD/MM/YYYY HH:mm") : "—");

export function formatar(valor, formato) {
  if (formato === "brl") return fmtBRL(valor);
  if (formato === "pct") return fmtPct(valor);
  if (formato === "razao") return fmtRazao(valor);
  return fmtInt(valor);
}
